import { InvitationType, PeakSource } from "@/enums/enums";
import { AccessToken, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class UserService {
  DoGetUserDetailForDisplay(userIdList: any) {
    return service.peakExportAPI
      .post(
        "/api/User/GetUserDetailListForDisplay",
        {
          merchantId: MerchantId(),
          userIdList: userIdList,
        },
        SetHeaderService()
      )
      .then((res: any) => {
        return res;
      })
      .catch((err: any) => err);
  }
  DoUpdateReferFriendStatusCaseCreateMerchant(input: any) {
    const _input = {
      merchantId: input.merchantId,
    };
    return service.peakRealTimeAPI
      .post("/api/User/DoUpdateReferFriendStatusCaseCreateMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoRefreshMerchantList() {
    return service.peakAuthen.post("/connect/userinfo", "", {
      headers: {
        Authorization: `Bearer ${AccessToken()}`,
      },
    });
  }
  DoRegister(input: any) {
    const _input = {
      userProfileModel: input,
      source: PeakSource.PeakTax,
      language: i18n.locale,
    };
    return service.peakRealTimeAPI.post("/api/User/Register", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoAcceptInvitation(input: any) {
    const _input = {
      invitationId: input.invitationId,
      invitationCode: input.invitationCode,
    };
    return service.peakRealTimeAPI.post("/api/User/AcceptInvitation", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetUserDetail(userId: number) {
    const headers = SetHeaderService().headers;
    const params = { userId: userId };
    return service.peakRealTimeAPI.get("/api/User/GetUserRoleDetailByUserId", { params, headers }).then((res) => {
      return res;
    });
  }
  DoUpdateUserProfile(userTemplate: any) {
    const _input = {
      merchantId: MerchantId(),
      userTemplate: userTemplate,
    };
    return service.peakRealTimeAPI.post("/api/User/UpdateUserProfile", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoChangePassword(input: any) {
    const _input = {
      merchantId: MerchantId(),
      password: input.password,
      newPassword: input.newPassword,
    };
    return service.peakRealTimeAPI.post("/api/User/ChangePassword", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSettingUserTable(input: any) {
    const _input = {
      merchantId: MerchantId(),
      pageNumber: input.pageNo,
      pageSize: input.pageSize,
      searchText: input.searchText,
      userOrderBy: input.transactionTableView,
      tableSorting: input.tableSorting,
    };
    return service.peakExportAPI.post("/api/User/GetUserTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoRemoveUser(input: any) {
    const _input = {
      merchantId: MerchantId(),
      fromMerchantId: input.fromMerchantId,
      removeUserId: input.userId,
    };
    return service.peakRealTimeAPI.post("/api/User/RemoveUser", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateUserRole(input: any) {
    const _input = {
      merchantId: MerchantId(),
      userId: input.userId,
      userRole: input.userRole,
    };
    return service.peakRealTimeAPI.post("/api/Merchant/UpdateUserRole", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoAddNewUser(userRoleDetail: any) {
    const _input = {
      merchantId: MerchantId(),
      userRoleDetail: userRoleDetail,
      invitationType: InvitationType.InviteUserToMerchant,
      language: i18n.locale,
      source: PeakSource.PeakTax,
    };
    return service.peakRealTimeAPI.post("/api/User/AddNewUser", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoSetForgotPwd(userName: string) {
    const _input = {
      userName: userName,
      language: i18n.locale,
      source: PeakSource.PeakTax,
    };
    return service.peakRealTimeAPI.post("/api/User/SetForgotPwd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetForgotPwd(input: any) {
    const _input = {
      forgotPwdId: input.forgotPwdId,
      forgotPwdCode: input.forgotPwdCode,
    };
    return service.peakRealTimeAPI.post("/api/User/GetForgotPwd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoResetPwd(input: any) {
    const _input = {
      forgotPwdId: input.forgotPwdId,
      forgotPwdCode: input.forgotPwdCode,
      password: input.password,
      source: PeakSource.PeakTax,
    };
    return service.peakRealTimeAPI.post("/api/User/ResetPwd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoInsertUserProfileConsent(input: any) {
    const _input = {
      userId: input.userId,
      isConsentTerm: input.isConsentTerm,
    };
    return service.peakRealTimeAPI
      .post("/api/User/InsertUserProfileConsent", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetUserProfileConsent(userId: any) {
    const _input = {
      userId: userId,
    };
    return service.peakRealTimeAPI.post("/api/User/GetUserProfileConsent", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoSendVideoFeedback(input: any) {
    return service.peakExportAPI
      .post("/api/User/UserFeedbackVideo", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }
  DoGetVideoFeedback(input: any) {
    return service.peakExportAPI
      .post("/api/User/GetUserFeedbackVideo", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }
  DoValidateUsername(username: string) {
    const input = {
      username: username,
    };
    return service.peakRealTimeAPI
      .post("/api/User/ValidateUsername", input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err: any) => err);
  }
}
export default new UserService();
